import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrack, Sparkles } from 'lucide-react';
export function TrianguloNoche() {
  return <section className="py-14 px-6 relative overflow-hidden" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-402">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[var(--accent)] opacity-[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-403" />

      <div className="max-w-[720px] mx-auto relative z-10" data-id="element-404">
        <div className="text-center mb-10" data-id="element-405">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-3" data-id="element-406">
            El Mecanismo Único
          </p>
          <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] mb-4" data-id="element-407">
            Dios no usa el dolor para destruirte.
            <br data-id="element-408" />
            <span className="text-[var(--accent)] italic" data-id="element-409">
              Lo usa para vaciarte.
            </span>
          </h2>
          <p className="text-[var(--text-muted)] max-w-lg mx-auto" data-id="element-410">
            Hay algo que nadie te ha explicado sobre cómo opera Dios con las
            personas que Él ha elegido para algo grande.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-stretch mb-10" data-id="element-411">
          <div className="bg-[var(--bg-elevated)] p-6 rounded-lg border border-[var(--border-subtle)] opacity-80 flex flex-col" data-id="element-412">
            <div className="flex items-center gap-3 mb-3 text-[var(--text-muted)]" data-id="element-413">
              <HeartCrack className="w-5 h-5" data-id="element-414" />
              <h3 className="font-bold uppercase tracking-wide text-sm" data-id="element-415">
                La Vasija Llena
              </h3>
            </div>
            <p className="text-sm leading-relaxed text-[var(--text-muted)] flex-1" data-id="element-416">
              Una vasija llena de sí misma no puede ser llenada por Dios. Una
              persona cuya identidad depende de una relación, un trabajo o un
              título, no puede recibir lo nuevo.
            </p>
          </div>

          <div className="bg-[var(--bg-card)] p-6 rounded-lg border border-[var(--accent)]/25 shadow-sm relative overflow-hidden flex flex-col" data-id="element-417">
            <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-418"></div>
            <div className="flex items-center gap-3 mb-3 text-[var(--accent)]" data-id="element-419">
              <Sparkles className="w-5 h-5" data-id="element-420" />
              <h3 className="font-bold uppercase tracking-wide text-sm" data-id="element-421">
                La Cirugía Divina
              </h3>
            </div>
            <p className="text-[var(--text-primary)] text-sm leading-relaxed font-medium flex-1" data-id="element-422">
              Primero tiene que perder lo que la tenía limitada. Eso no es
              castigo. Eso es cirugía. Ningún cirujano destruye a su paciente.
              Lo abre para sanar lo que por fuera no se puede ver.
            </p>
          </div>
        </div>

        {/* The realization */}
        <div className="bg-[var(--bg-card)] rounded-xl border border-[var(--accent)]/20 p-8 mb-8 text-center" data-id="element-423">
          <h3 className="text-xl font-serif text-[var(--text-heading)] mb-4" data-id="element-424">
            Estás en la mesa de operaciones
          </h3>
          <p className="text-[var(--text-primary)] text-lg leading-relaxed mb-6" data-id="element-425">
            Ahí estás tú. Abierto. Expuesto. Vulnerable. Sintiéndote roto. Pero
            lo que parece destrucción desde adentro, es en realidad el
            procedimiento más importante de tu vida.
          </p>

          <div className="inline-block border-t border-b border-[var(--accent)]/30 py-3 px-6" data-id="element-426">
            <p className="font-serif italic text-[var(--text-heading)] text-xl" data-id="element-427">
              "El problema no es que Dios te haya abandonado. El problema es que
              nadie te ha dado el mapa para entender dónde estás dentro de Su
              proceso."
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-428">
          <p className="text-[var(--text-muted)] text-sm uppercase tracking-widest mb-2" data-id="element-429">
            Eso es exactamente lo que vas a encontrar en:
          </p>
        </div>
      </div>
    </section>;
}